import { CSSProperties, useEffect, useRef } from 'react';
import { DownloadOnlyDataPackageFeature, StudyIpdDataPackageFeature } from '@vivli/shared/features/data-package/feature';
import { Size, Styles } from '@vivli/shared/theme';
import { useUserPermissions } from '@vivli/features/users/infrastructure/hook';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { usePubliclyAvailableFiles, useStudyContext } from '@vivli/features/studies/infrastructure/context';
import { useDataPackageFileTypes } from '@vivli/shared/features/data-package/infrastructure/hook';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { IDataPackage, IDataPackageFileDescriptor } from '@vivli/shared/features/data-package/infrastructure/interface';
import { DataPackageStatusEnum } from '@vivli/features/studies/infrastructure/enum';
import { IDataPackageInternalApi } from '@vivli/shared/infrastructure/hook';

const containerStyle: CSSProperties = {};

const innerContainerStyle: CSSProperties = {
    flex: 'auto',
    marginBottom: 20,
    paddingRight: Size.PADDING
};

interface AdminStudyDatasetDatapackageComponentProps {
    ipdDataPackageId: string;
    userCanDownload: boolean;
    userCanUpload: boolean;
    studyId: string;
    studyIpdContentType: any;
    studyOrgId: string;
}

export const AdminStudyDatasetDatapackageComponent = ({
    ipdDataPackageId,
    userCanDownload,
    userCanUpload,
    studyId,
    studyIpdContentType
}: AdminStudyDatasetDatapackageComponentProps) => {
    const { study } = useStudyContext();
    const { hasPermission } = useActiveUserContext();
    const dataPackageFileTypes = useDataPackageFileTypes();
    const { setDataPackage, dataPackage } = usePubliclyAvailableFiles();

    const showUpload = userCanUpload;
    //TODO PERMFE - redo with permissions+
    const showDownloadAdmin = hasPermission(PermissionsEnum.EditStudyAdv);
    const showDownload = userCanDownload && !showUpload && !hasPermission(PermissionsEnum.EditStudyAdv);
    const downloadMessage = showDownload
        ? 'SUBMITTED DATA PACKAGE CONTENTS - PRESS DOWNLOAD BUTTON TO DOWNLOAD EACH FILE'
        : showDownloadAdmin
          ? 'VIEW FILES IN DATA PACKAGE'
          : 'SUBMIT DATA PACKAGE';
    const showPubliclyAvailable =
        hasPermission(PermissionsEnum.EditStudyAdv) || /*org admin or data provider*/ useUserPermissions().canUploadIpd(study?.orgId);

    return (
        <div style={containerStyle}>
            <div style={Styles.FORM_ROW}>
                {(showDownload || showDownloadAdmin) && (
                    <div style={innerContainerStyle}>
                        <DownloadOnlyDataPackageFeature
                            dataPackageId={ipdDataPackageId}
                            disallowDownload={showDownloadAdmin}
                            showPubliclyAvailable={showPubliclyAvailable}
                            studyOrgId={study?.orgId}
                            showVerifyButton={true}
                            title={downloadMessage}
                            onDataPackageLoaded={setDataPackage}
                            onPackageUpdated={setDataPackage}
                            overrideDataPackage={dataPackage}
                            {...dataPackageFileTypes}
                        />
                    </div>
                )}
                {showUpload && (
                    <div style={innerContainerStyle}>
                        <StudyIpdDataPackageFeature
                            dataPackageId={ipdDataPackageId}
                            ipdContentType={studyIpdContentType}
                            studyId={studyId}
                            showExternalLinks={false}
                            title={downloadMessage}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
